import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from './translations/en/translation.json';

i18next.use(initReactI18next)
  .init({
      debug: true,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
      resources: {
        en: {
          translation,
        },
      },
    },
  );
